import { compareAsc } from 'date-fns';
import * as yup from 'yup';
import { parseISODate, startOfDay, startOfToday, subDays, } from '@zurich/common/forms';
import { isIBAN, restrictedIBANs } from '../utils';
import { apiFieldValidationSchemaUtils } from '../utils/apiFieldValidationSchemaUtils';
import { isExactlyNineOrElevenCharacters, isValidZurichVBFormat, validateIBANCountryCode, } from './helpers';
export const paymentWaySchema = yup.string().required('required');
export const paymentIntervalSchema = yup.string().required('required');
export const partyPolicyCancellationDateSchema = yup.object({
    validUntil: yup
        .date()
        .typeError('required')
        .transform(parseISODate)
        .test('before fromDate', '1', (validUntil) => {
        if (validUntil) {
            return (compareAsc(subDays(startOfToday(), 1), startOfDay(validUntil)) < 0);
        }
        return false;
    }),
});
export const requestPaymentSchema = yup
    .string()
    .nullable()
    .notOneOf(restrictedIBANs, '1')
    .test('isRequestPaymentsIBAN', '1', (value) => (value ? isIBAN(value) : true))
    .required('required');
export const requestPaymentBICSchema = yup
    .string()
    .nullable()
    .required('required')
    .min(8, 'min8max11')
    .max(11, 'min8max11')
    .test('alphanumeric', 'min8max11', (value) => value ? /^[a-zA-Z0-9]*$/.test(value) : true)
    .test('matches IBAN country code', 'ibanCountryCodeMatch', (value, context) => validateIBANCountryCode(value, context));
export const requestPaymentBICApiValidationSchema = apiFieldValidationSchemaUtils.createApiFieldValidationSchema((value) => !!value, [404]);
export const paymentDataSepaCheckboxSchema = yup
    .string()
    .nullable()
    .required('required')
    .oneOf(['true'], 'required');
export const insuranceConfirmationNoSchema = yup
    .string()
    .test('isValidZurichVBFormat', '1', isValidZurichVBFormat)
    .min(9, '1')
    .max(11)
    .test('exactly 9 or 11 characters', '1', isExactlyNineOrElevenCharacters)
    .required('required')
    .nullable();
